import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

// Persistent marker that this is the isolated demo/training environment —
// not the real app. Renders on every route (mounted at the App root,
// outside the router). Self-hides unless REACT_APP_DEMO=true, so it never
// appears in production. Dismissable for the browser session only: it
// comes back on the next visit so nobody mistakes demo for live.
const KEY = 'ml-demo-banner-dismissed';

export default function DemoBanner() {
  const [hidden, setHidden] = useState(() => {
    try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; }
  });
  const showing = process.env.REACT_APP_DEMO === 'true' && !hidden;
  // The app shells pad their scroll pane by the banner's height while it
  // shows (App.css: html[data-demo-banner]) so it never covers the last row.
  useEffect(() => {
    if (showing) document.documentElement.setAttribute('data-demo-banner', '1');
    else document.documentElement.removeAttribute('data-demo-banner');
    return () => document.documentElement.removeAttribute('data-demo-banner');
  }, [showing]);
  if (!showing) return null;

  const dismiss = () => {
    try { sessionStorage.setItem(KEY, '1'); } catch { /* storage blocked — hide for this render only */ }
    setHidden(true);
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2147483647,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '6px 44px 6px 12px',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.02em',
        color: '#fff',
        background: 'linear-gradient(90deg, #0DA7CA, #22346A)',
        boxShadow: '0 -1px 8px rgba(0,0,0,0.18)',
      }}
    >
      <span style={{ display: 'inline-block', width: 7, height: 7, borderRadius: '50%', background: '#fff' }} />
      <span style={{ whiteSpace: 'nowrap' }}>DEMO ENVIRONMENT</span>
      <span className="demo-banner-long" style={{ whiteSpace: 'nowrap' }}>— sample data only, resets nightly. Not the live app.</span>
      <span className="demo-banner-short" style={{ whiteSpace: 'nowrap' }}>— sample data, resets nightly</span>
      <button
        onClick={dismiss}
        aria-label="Hide demo banner for this session"
        title="Hide for this session"
        style={{
          position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
          width: 24, height: 24, borderRadius: 6, border: 'none', cursor: 'pointer',
          background: 'rgba(255,255,255,0.18)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        <X size={13} strokeWidth={2.4} />
      </button>
    </div>
  );
}
